/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Rental_Reserve_BtnInputs */

const en_rental_reserve_btn = /** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reserve ${i?.total}`)
};

const es_rental_reserve_btn = /** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reservar ${i?.total}`)
};

const fr_rental_reserve_btn = /** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réserver ${i?.total}`)
};

const de_rental_reserve_btn = /** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buchen ${i?.total}`)
};

const id_rental_reserve_btn = /** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pesan — ${i?.total}`)
};

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const ja_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const zh_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const ar_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const it_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const ru_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const pt_rental_reserve_btn = en_rental_reserve_btn;

/** @type {(inputs: Rental_Reserve_BtnInputs) => LocalizedString} */
const ko_rental_reserve_btn = en_rental_reserve_btn;

/**
* | output |
* | --- |
* | "Reserve {total}" |
*
* @param {Rental_Reserve_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_reserve_btn = /** @type {((inputs: Rental_Reserve_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Reserve_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_reserve_btn(inputs)
	if (locale === "es") return es_rental_reserve_btn(inputs)
	if (locale === "fr") return fr_rental_reserve_btn(inputs)
	if (locale === "de") return de_rental_reserve_btn(inputs)
	if (locale === "ja") return ja_rental_reserve_btn(inputs)
	if (locale === "zh") return zh_rental_reserve_btn(inputs)
	if (locale === "ar") return ar_rental_reserve_btn(inputs)
	if (locale === "id") return id_rental_reserve_btn(inputs)
	if (locale === "it") return it_rental_reserve_btn(inputs)
	if (locale === "ru") return ru_rental_reserve_btn(inputs)
	if (locale === "pt") return pt_rental_reserve_btn(inputs)
	return ko_rental_reserve_btn(inputs)
});